import { getRandomItem } from "./utils";

export const siteName = "oluoko.dev";
export const darkPrimaryColor = "#ffdd00";
export const lightPrimaryColor = "#ffff00";
export const defaultSpaceLg = 25;
export const defaultSpace = 10;
export const defaultBorderRadius = 15;
export const defaultTransitionDuration = 300;

export const colors = [
  {
    default: { name: "Forest Green", value: "#4b633b" },
    dark: { name: "Steel", value: "#0c0402" },
    light: { name: "Slate", value: "#ABBAAF" },
  },
  {
    default: { name: "Tangerine", value: "#f3893a" },
    dark: { name: "Quartz", value: "#131313" },
    light: { name: "Ink", value: "#E9DfD3" },
  },
  {
    default: { name: "Blue Grotto", value: "#116b98" },
    dark: { name: "Coal", value: "#0b0201" },
    light: { name: "Brown", value: "#bc9476" },
  },
];

export const tileImages = [
  "1.jpeg",
  "105.jpeg",
  "12.jpeg",
  "130.jpeg",
  "19.jpeg",
  "25.jpeg",
  "31.jpeg",
  "111.jpeg",
  "134.png",
  "128.jpeg",
  "143.jpeg",
  "38.jpeg",
  "44.jpeg",
  "50.jpeg",
  "133.png",
  "57.jpg",
  "63.jpeg",
  "135.png",
  "7.jpeg",
  "144.gif",
  "112.jpeg",
  "76.jpeg",
  "82.jpg",
  "89.jpeg",
  "95.jpeg",
  "10.jpeg",
  "106.jpeg",
  "113.jpeg",
  "13.jpeg",
  "2.jpeg",
  "26.jpeg",
  "136.png",
  "32.jpeg",
  "39.jpg",
  "45.jpeg",
  "51.jpeg",
  "58.jpeg",
  "64.jpeg",
  "114.jpeg",
  "70.jpeg",
  "77.jpeg",
  "83.jpeg",
  "9.jpeg",
  "129.jpeg",
  "96.jpeg",
  "100.jpeg",
  "115.jpeg",
  "107.jpeg",
  "14.jpeg",
  "137.png",
  "20.jpeg",
  "27.jpeg",
  "33.jpeg",
  "4.jpeg",
  "46.jpeg",
  "116.jpeg",
  "52.jpeg",
  "59.jpeg",
  "65.jpeg",
  "71.jpeg",
  "78.jpeg",
  "84.jpg",
  "138.png",
  "90.jpeg",
  "117.jpeg",
  "97.jpeg",
  "101.jpeg",
  "108.jpeg",
  "15.jpeg",
  "21.jpeg",
  "28.gif",
  "118.jpeg",
  "126.jpeg",
  "34.jpeg",
  "40.jpeg",
  "47.jpeg",
  "53.jpeg",
  "6.jpeg",
  "66.jpeg",
  "139.png",
  "119.jpeg",
  "72.jpeg",
  "79.jpeg",
  "85.jpeg",
  "91.jpeg",
  "98.jpeg",
  "102.jpeg",
  "145.gif",
  "109.jpeg",
  "16.jpeg",
  "22.jpeg",
  "29.jpeg",
  "35.jpeg",
  "41.jpeg",
  "48.jpeg",
  "120.jpeg",
  "54.jpeg",
  "60.jpeg",
  "67.jpeg",
  "142.jpeg",
  "73.jpeg",
  "121.jpeg",
  "8.jpeg",
  "86.jpeg",
  "92.jpeg",
  "99.jpeg",
  "103.jpeg",
  "11.jpeg",
  "141.jpeg",
  "122.jpeg",
  "17.jpeg",
  "23.jpeg",
  "3.jpeg",
  "36.jpeg",
  "42.jpeg",
  "49.jpeg",
  "123.jpeg",
  "55.jpeg",
  "61.jpeg",
  "68.jpeg",
  "74.jpeg",
  "80.jpeg",
  "87.jpeg",
  "124.jpeg",
  "93.jpeg",
  "104.jpeg",
  "110.jpeg",
  "18.jpeg",
  "131.jpeg",
  "24.jpeg",
  "125.jpeg",
  "30.jpeg",
  "37.jpeg",
  "132.png",
  "43.jpeg",
  "5.jpeg",
  "56.jpeg",
  "140.jpeg",
  "62.jpeg",
  "69.jpeg",
  "75.jpeg",
  "81.jpeg",
  "88.jpeg",
  "94.jpeg",
  "146.jpg",
  "147.jpg",
  "148.jpg",
  "149.jpg",
  "150.jpg",
  "151.jpg",
  "152.jpg",
  "153.jpg",
  "154.gif",
  "155.gif",
  "156.jpg",
  "157.jpg",
  "158.jpg",
  "159.jpg",
  "160.jpg",
  "161.jpg",
  "162.jpg",
  "163.jpg",
  "164.jpg",
];

export const defaultProjectImages = [
  "hello-world.gif",
  "keyboard.jpg",
  "code-concept-art.jpg",
  "htl-tags.png",
];

export const images = [
  "brian-s gif.gif",
  "green blob.png",
  "heroImage.png",
  "me in a newspaper clipping.png",
  "me in a newspaper clipping2.png",
  "vinyl record.png",
  "profile pic.png",
];
